<template>
  <div>
    <Navbar></Navbar>
    <div class="container mt-3 mt-lg-5">

      <!-- TITLE-->
      <div class="row align-content-center mb-3">
        <div class="col-md-12">
          <vue-aos animation-class="animate__animated animate__flipInX">
            <div>
              <h1 class="fw-500 typography-headline-lg">Color {{ color }}</h1>
              <p class="subtitle-1 text-muted mb-3">Change the color to preview shades and tints.</p>
            </div>
          </vue-aos>
        </div>
      </div>

      <div class="row mb-5">
        <div class="col-md-4">
          <label for="input-color" class="mb-2">Color picker</label>
          <div class="d-flex align-items-center">
            <color-picker v-model="color" mode="hex"></color-picker>
            <input type="text" class="form-control form-big-height w-75 ms-2" id="input-color" v-model="color">
          </div>
        </div>
      </div>

      <!-- COLOR SHADES -->
      <div class="row mb-5">
        <div class="col-md-12 mb-3">
          <h2 class="fw-500 typography-headline-sm mb-0">Shades of {{ color }}</h2>
        </div>
        <div class="col-md-12">
          <div class="palette palette-h-lg d-flex justify-content-around">
            <div class="palette-item d-grid align-items-center" :style="{'background': originalColor()}">
              <p v-text="originalColor()" :class="[colorOriginal ? 'text-white' : 'text-dark']"
                  class="d-none d-md-block typography-headline-sm mb-0"></p>
              <div class="palette-color d-md-none" v-text="originalColor()"></div>
            </div>
            <div class="palette-item d-grid align-items-center" :style="{'background': darken5Color()}">
              <p v-text="darken5Color()" :class="[colorDarken5 ? 'text-white' : 'text-dark']"
                  class="d-none d-md-block typography-headline-sm mb-0"></p>
              <div class="palette-color d-md-none" v-text="darken5Color()"></div>
            </div>
            <div class="palette-item d-grid align-items-center" :style="{'background': darken15Color()}">
              <p v-text="darken15Color()" :class="[colorDarken15 ? 'text-white' : 'text-dark']"
                  class="d-none d-md-block typography-headline-sm mb-0"></p>
              <div class="palette-color d-md-none" v-text="darken15Color()"></div>
            </div>
            <div class="palette-item d-grid align-items-center" :style="{'background': darken30Color()}">
              <p v-text="darken30Color()" :class="[colorDarken30 ? 'text-white' : 'text-dark']"
                  class="d-none d-md-block typography-headline-sm mb-0"></p>
              <div class="palette-color d-md-none" v-text="darken30Color()"></div>
            </div>
            <div class="palette-item d-grid align-items-center" :style="{'background': darken40Color()}">
              <p v-text="darken40Color()" :class="[colorDarken40 ? 'text-white' : 'text-dark']"
                  class="d-none d-md-block typography-headline-sm mb-0"></p>
              <div class="palette-color d-md-none" v-text="darken40Color()"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- COLOR TINTS -->
      <div class="row mb-5">
        <div class="col-md-12 mb-3">
          <h2 class="fw-500 typography-headline-sm mb-0">Tints of {{ color }}</h2>
        </div>
        <div class="col-md-12">
          <div class="palette palette-h-lg d-flex justify-content-around">
            <div class="palette-item d-grid align-items-center" :style="{'background': originalColor()}">
              <p v-text="originalColor()" :class="[colorOriginal ? 'text-white' : 'text-dark']"
                  class="d-none d-md-block typography-headline-sm mb-0"></p>
              <div class="palette-color d-md-none" v-text="originalColor()"></div>
            </div>
            <div class="palette-item d-grid align-items-center" :style="{'background': brighter5Color()}">
              <p v-text="brighter5Color()" :class="[colorBrighter5 ? 'text-dark' : 'text-white']"
                  class="d-none d-md-block typography-headline-sm mb-0"></p>
              <div class="palette-color d-md-none" v-text="brighter5Color()"></div>
            </div>
            <div class="palette-item d-grid align-items-center" :style="{'background': brighter15Color()}">
              <p v-text="brighter15Color()" :class="[colorBrighter15 ? 'text-dark' : 'text-white']"
                  class="d-none d-md-block typography-headline-sm mb-0"></p>
              <div class="palette-color d-md-none" v-text="brighter15Color()"></div>
            </div>
            <div class="palette-item d-grid align-items-center" :style="{'background': brighter30Color()}">
              <p v-text="brighter30Color()" :class="[colorBrighter30 ? 'text-dark' : 'text-white']"
                  class="d-none d-md-block typography-headline-sm mb-0"></p>
              <div class="palette-color d-md-none" v-text="brighter30Color()"></div>
            </div>
            <div class="palette-item d-grid align-items-center" :style="{'background': brighter40Color()}">
              <p v-text="brighter40Color()" :class="[colorBrighter40 ? 'text-dark' : 'text-white']"
                  class="d-none d-md-block typography-headline-sm mb-0"></p>
              <div class="palette-color d-md-none" v-text="brighter40Color()"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from "@/components/includes/Navbar";
import Footer from "@/components/includes/Footer";
import VueAos from 'vue-aos'
import tinycolor from 'tinycolor2'

export default {
  name: "Color",
  metaInfo: {
    title: 'Color',
  },
  components: {Navbar, Footer, VueAos},
  data() {
    return {
      color: '#03a9f4',
      colorBrighter5: '',
      colorBrighter15: '',
      colorBrighter30: '',
      colorBrighter40: '',
      colorOriginal: '',
      colorDarken5: '',
      colorDarken15: '',
      colorDarken30: '',
      colorDarken40: '',
    }
  },
  methods: {
    // COLOR ORIGINAL
    originalColor() {
      const color = tinycolor(this.color)
      this.colorOriginal = color.isDark()
      return this.color
    },
    // COLOR TINTS
    brighter5Color() {
      const color = tinycolor(this.color)
      this.colorBrighter5 = color.isLight()
      return tinycolor(this.color).brighten(5).toString()
    },
    brighter15Color() {
      const color = tinycolor(this.color)
      this.colorBrighter15 = color.isLight()
      return tinycolor(this.color).brighten(15).toString()
    },
    brighter30Color() {
      const color = tinycolor(this.color)
      this.colorBrighter30 = color.isLight()
      return tinycolor(this.color).brighten(30).toString()
    },
    brighter40Color() {
      const color = tinycolor(this.color)
      this.colorBrighter40 = color.isLight()
      return tinycolor(this.color).brighten(40).toString()
    },
    // COLOR SHADES
    darken5Color() {
      const color = tinycolor(this.color)
      this.colorDarken5 = color.isDark()
      return tinycolor(this.color).darken(5).toString()
    },
    darken15Color() {
      const color = tinycolor(this.color)
      this.colorDarken15 = color.isDark()
      return tinycolor(color).darken(15).toString()
    },
    darken30Color() {
      const color = tinycolor(this.color)
      this.colorDarken30 = color.isDark()
      return tinycolor(color).darken(30).toString()
    },
    darken40Color() {
      const color = tinycolor(this.color)
      this.colorDarken40 = color.isDark()
      return tinycolor(color).darken(40).toString()
    }
  }
}
</script>